import v1FooterLangNav from './v1FooterLangNav';
import v1FooterCta from './v1FooterCta';

export default function v1Footer() {
  window.addEventListener('load', () => {
    v1FooterLangNav();
  });
  v1FooterCta();
}
